var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomePage'),_c('v-spacer'),_c('AkivaServices'),_c('Markets'),_c('ContactSimple')],1)}
var staticRenderFns = []

export { render, staticRenderFns }